module.exports = __webpack_public_path__ + "static/media/donation.5de64edf.png";